/**
 * P云模块日志工具
 * 根据配置控制台日志输出级别
 */

import { debugConsole } from '../../config/pyunConfig'

// 日志级别优先级
const LOG_LEVELS = {
  off: 0,
  error: 1,
  warn: 2,
  info: 3,
  debug: 4
}

// 获取当前配置的日志级别
const currentLevel = LOG_LEVELS[debugConsole] || LOG_LEVELS.error

/**
 * 日志工具
 * 只有当配置级别 >= 日志级别时才输出
 */
export const logger = {
  info (...args) {
    if (currentLevel >= LOG_LEVELS.info) {
      console.log(...args)
    }
  },

  warn (...args) {
    if (currentLevel >= LOG_LEVELS.warn) {
      console.warn(...args)
    }
  },

  error (...args) {
    if (currentLevel >= LOG_LEVELS.error) {
      console.error(...args)
    }
  },

  debug (...args) {
    if (currentLevel >= LOG_LEVELS.debug) {
      console.log('[DEBUG]', ...args)
    }
  },

  success (...args) {
    if (currentLevel >= LOG_LEVELS.info) {
      console.log('%c✅ ' + args[0], 'color: green; font-weight: bold', ...args.slice(1))
    }
  }
}

export default logger
